import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Flex, Typography } from "antd";
import Icon from "../../../../../Icon";
import "./EnrollmentCodesListItem.less";

const { Text } = Typography;

dayjs.extend(utc);

const EnrollmentCodesListItem = ({ item }) => {
  const [isCopied, setIsCopied] = useState(false);
  const codeType = (item.type || item.code_type || "").toUpperCase();
  const createdAt = item.createdAt || (item.created
    ? `Added on ${dayjs.utc(item.created).format("DD MMM YYYY h:mm A [(UTC)]")}`
    : "");

  const handleCopy = () => {
    navigator.clipboard.writeText(item.code);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1500);
  };

  return (
    <Flex
      align="center"
      justify="space-between"
      className="enrollment-codes-list-item"
    >
      <Flex align="center" gap={12} className="enrollment-codes-list-item-main">
        <Text className="enrollment-codes-list-item-type">
          {codeType}
        </Text>

        <Text strong className="enrollment-codes-list-item-code" ellipsis>
          {item.code}
        </Text>

        <button
          type="button"
          className="enrollment-codes-list-item-copy"
          onClick={handleCopy}
        >
          {isCopied ? <Icon className="check-copied" type="check" /> : <Icon type="copy" />}
        </button>
      </Flex>

      <Text
        type="secondary"
        className="enrollment-codes-list-item-date"
      >
        {createdAt}
      </Text>
    </Flex>
  );
};

export default EnrollmentCodesListItem;
